import {
  Cell, Legend, Pie, ResponsiveContainer, PieChart, Label, Tooltip,
} from 'recharts';
import React from 'react';
import Proptypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { PieChartShape } from './PieChartShape';

const useStyles = buildUseStyles('PieChart', (_) => ({
  root: {
    display: 'flex',
    '& .recharts-surface': {
      overflow: 'visible',
    },
    '& .recharts-pie-sector': {
      cursor: 'pointer',
    },
  },

}));

// Adapted from AnalyzeYourExpensesChart. This is likely a good candidate to go in FD once we decide on an interface
// that we like here for this component
export const PieChartWithLegend = ({
  labelText,
  data,
  aspectRatio,
  handleChartOnClick,
  labelFormatter,
  renderLegend,
  legendProps,
  chartHeight,
  chartWidth,
  isDonut,
  activeIndex,
}) => {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <ResponsiveContainer aspect={aspectRatio} minWidth={chartWidth} minHeight={chartHeight} className={classes.root}>
      <PieChart>
        <Pie
          activeShape={PieChartShape}
          inactiveShape={PieChartShape}
          data={data}
          dataKey="value"
          outerRadius="100%"
          innerRadius={isDonut ? '60%' : undefined}
          startAngle={90}
          endAngle={450}
          strokeWidth={1}
          onClick={handleChartOnClick}
        >
          {labelText ? <Label
            value={labelText}
            position="center"
            fontSize={18}
            fill={theme.palette.facet.oceana800}
          /> : null}
          {data.map((entry) => <Cell key={entry.label} fill={entry.color} />)}
        </Pie>
        <Legend
          layout="vertical"
          formatter={labelFormatter}
          iconType={'circle'}
          content={renderLegend}
          {...legendProps}
        />
        <Tooltip active defaultIndex={activeIndex} content={() => null} />
      </PieChart>
    </ResponsiveContainer>
  );
};

PieChartWithLegend.defaultProps = {
  data: [],
  aspectRatio: undefined,
  handleChartOnClick: noop,
  legendProps: {},
  chartHeight: 400,
  chartWidth: 300,
  isDonut: false,
  labelText: null,
  activeIndex: undefined,
};


PieChartWithLegend.propTypes = {
  data: Proptypes.array,
  aspectRatio: Proptypes.number,
  handleChartOnClick: Proptypes.func,
  labelFormatter: Proptypes.func.isRequired,
  renderLegend: Proptypes.func.isRequired,
  legendProps: Proptypes.object,
  chartHeight: Proptypes.number,
  chartWidth: Proptypes.number,
  isDonut: Proptypes.bool,
  labelText: Proptypes.string,
  activeIndex: Proptypes.number,
};
